<template>
    <div class="table-box">
        <div :class="['table-header', {'table-header--filters': hasFilters}]">
            <div v-if="hasFilters" class="table-filters">
                <data-table-filters>
                    <slot name="tableFilters">
                    </slot>
                        <v-layout>
                        <div v-if="hasFilters" class="table-search">
                        <div class="table-button">
                            <sp-button @click.native="resetFilters" text="reset" icon="reset"></sp-button>
                        </div>
                        <div class="table-button">
                            <sp-button @click.native="getItems" text="search" icon="search"></sp-button>
                        </div>
                        </div>
                    </v-layout>
                </data-table-filters>
            </div>
            <div class="table-header__wrapper">
                <div class="table-title" v-if="title">
                    {{ title }}
                </div>
                <div v-if="!hasFilters" class="table-search">
                    <v-text-field
                        @input="getItems"
                        v-model.lazy="search"
                        append-icon="search"
                        :label="$t('listFleet.forms.search.label')"
                        single-line
                        hide-details
                        clearable
                        class="v-btn--search"
                    ></v-text-field>
                </div>
            </div>
        </div>
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            item-key="id"
            select-all
            hide-actions
            :pagination.sync="pagination"
            :loading="loading"
            :page.sync="page"
            :total-items="totalItems"
        >
            <template v-slot:items="props">
                <td>
                    <v-checkbox
                        v-model="props.selected"
                        primary
                        hide-details
                    ></v-checkbox>
                </td>
                <slot name="items" v-bind:props="props"></slot>
                <td class="text-center" v-if="deletable">
                    <sp-button v-if="checkIfExcludeDeletable(props.item)" @click.native="deleteSingleItem(props.item)" design-type="table-button" icon="delete"></sp-button>
                </td>
            </template>
        </v-data-table>

        <div class="table-footer">
            <div class="table-pagination">
                <v-pagination v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
            </div>
            <div class="table-buttons">
                <div v-if="getPreparedDataToSave" class="margin-right">
                    <sp-button @click.native="exportToCSV" :disabled="totalItems === 0" sp-class="no-padding-right" icon="download" :class="{ 'disabled--white': totalItems === 0 }" text="Export to CSV"></sp-button>
                </div>
                <div v-if="getPreparedDataToSave" class="margin-right">
                    <sp-button @click.native="exportToPDF" :disabled="totalItems === 0" sp-class="no-padding-right" icon="download" :class="{ 'disabled--white': totalItems === 0 }" text="Export to PDF"></sp-button>
                </div>
                    <sp-button
                        v-if="deletable"
                        @click.native="openDeleteConfirmationDialog"
                        :disabled="this.selected.length === 0"
                        class="margin-right"
                        sp-class="no-padding-right"
                        icon="delete-white"
                        :text="$t('listFleet.buttons.delete.text')"
                        :small-text="deleteButtonText"
                    ></sp-button>

                <slot name="createButton">
                    <!-- <sp-button sp-class="no-padding-right" icon="car" text="Create"></sp-button> -->
                </slot>

                <slot name="createMultipleButton"></slot>

            </div>
        </div>

        <v-dialog
            v-model="deleteConfirmationDialog"
            max-width="350"
        >
            <v-card>
                <v-card-title class="headline">{{ $t('listFleet.modal.deleteConfirmation.title') }}</v-card-title>

                <v-card-text>
                    Are you sure you want to delete <strong>{{ deleteCount() }} items</strong>?
                </v-card-text>

                <v-card-actions>
                    <sp-button @click.native="closeDeleteConfirmationDialog" class="v-btn--small left" sp-class="gray" :text="$t('listFleet.modal.deleteConfirmation.cancelButton')"></sp-button>
                    <sp-button @click.native="deleteItems" class="v-btn--small" sp-class="primary" :text="$t('listFleet.modal.deleteConfirmation.okButton')"></sp-button>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import toast from '@/plugins/izitoast'
import jsPDF from 'jspdf'
import { camelCaseToSentence } from '@/helpers/Utils'
import DataTableFilters from '@/views/_components/DataTableFilters'

import { mapGetters } from 'vuex'

export default {
    name: 'DataTable',
    components: {
        DataTableFilters,
        SpButton
    },
    data () {
        return {
            deleteConfirmationDialog: false,
            deleteButtonClass: 'primary',
            loading: false,
            isLoading: false,
            totalItems: 0,
            page: 1,
            sortBy: null,
            tempDeleteCount: 0,
            pagination: {
                rowsPerPage: 10,
                maxButtons: 5,
                totalItems: 0,
                page: 1,
                descending: false
            },
            search: null,
            selected: [],
            singleDelete: null,
            items: [],
            reportImageUri: null,
            showPoweredBy: null
        }
    },
    props: {
        title: {
            type: String,
            required: false
        },
        deleteButtonText: {
            type: String,
            required: false
        },
        headers: {
            type: Array,
            required: true
        },
        resetFiltersHandler: {
            type: Function,
            required: false,
            default: () => {}
        },
        getItemsHandler: {
            type: Function,
            required: true
        },
        getDeleteHandler: {
            type: Function,
            required: true
        },
        getPreparedDataToSave: {
            type: Function,
            required: false,
            default: null
        },
        deletable: {
            type: Boolean,
            default: true
        },
        excludesDeletable: {
            type: Array,
            default: () => []
        },
        hasFilters: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        ...mapGetters('brandModule', [
            'getShowPoweredBy',
            'getReportImageUri'
        ]),
        pages () {
            if (null == this.pagination.rowsPerPage || null == this.totalItems) return 0

            return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
        }
    },
    watch: {
        pagination: {
            handler (newVal, oldVal) {
                if (false === this.pagination.descending) {
                    this.sortBy = '+' + this.pagination.sortBy
                } else if (true === this.pagination.descending) {
                    this.sortBy = '-' + this.pagination.sortBy
                } else {
                    this.sortBy = this.pagination.sortBy
                }

                if (1 !== newVal.page && (oldVal.descending !== newVal.descending)) return
                if (newVal.sortBy !== oldVal.sortBy && newVal.descending === oldVal.descending && oldVal.page === newVal.page) {
                    this.pagination.page = 1
                }
                this.getItems()
            },
            deep: true
        }
    },
    methods: {
        async getItems () {
            this.isLoading = true
            const data = await this.getItemsHandler(this.pagination.page, this.pagination.rowsPerPage, this.search, this.sortBy)

            this.items = data.items
            this.totalItems = data.total
            this.isLoading = false
        },
        deleteSingleItem (object) {
            this.singleDelete = object
            this.openDeleteConfirmationDialog()
        },
        deleteItems () {
            let promises = []
            if (this.singleDelete) {
                promises.push(this.getDeleteHandler(this.singleDelete))
            } else {
                promises = this.selected.reduce((promisesArray, item) => {
                    promisesArray.push(this.getDeleteHandler(item))
                    return promisesArray
                }, [])
            }

            Promise.all(promises).then(() => {
                this.getItems()
                this.deleteConfirmationDialog = false
                this.singleDelete = null
                this.selected.length = 0
            }).catch((e) => {
                console.error(e.message)
            })
        },

        openDeleteConfirmationDialog () {
            if (0 === this.selected.length && null == this.singleDelete) {
                toast.error(this.$t('listFleet.messages.delete.error.text'))
                return
            }

            this.deleteConfirmationDialog = true
        },
        closeDeleteConfirmationDialog () {
            if (this.singleDelete) {
                this.singleDelete = null
            }

            this.deleteConfirmationDialog = false
        },
        checkIfExcludeDeletable (item) {
            for (let excludeDeletable of this.excludesDeletable) {
                if (null != excludeDeletable.value && excludeDeletable.value === item[excludeDeletable.identifier]) {
                    return false
                }
            }

            return true
        },
        async exportToCSV () {
            let dataToSave = await this.getPreparedDataToSave(this.search)
            let csvContent = 'data:text/csv;charset=utf-8,'
            let headerArray = Object.keys(dataToSave[0]).map(el => {
                return camelCaseToSentence(el)
            })

            csvContent += [
                headerArray.join(';'),
                ...dataToSave.map(item => Object.values(item).join(';'))
            ]
                .join('\n')
                .replace(/(^\[)|(\]$)/gm, '')

            const data = encodeURI(csvContent)
            const link = document.createElement('a')
            link.setAttribute('href', data)
            link.setAttribute('download', this.title + '.csv')
            link.click()
        },
        getDataUri (url, cb) {
            let image = new Image()
            image.setAttribute('crossOrigin', 'anonymous')
            image.onload = function () {
                let canvas = document.createElement('canvas')
                canvas.width = this.naturalWidth
                canvas.height = this.naturalHeight
                canvas.getContext('2d').drawImage(this, 0, 0)

                cb(canvas.toDataURL('image/png'))
            }

            image.src = url
        },
        async exportToPDF () {
            // eslint-disable-next-line new-cap
            const pdf = new jsPDF({
                orientation: 'p',
                putOnlyUsedFonts: true,
                format: 'a4',
                unit: 'px'
            })

            const img = new Image()
            if (this.getReportImageUri) {
                this.getDataUri(this.getReportImageUri, async (dataUri) => {
                    img.src = dataUri

                    pdf.addImage(img, 'png', 150, 10, 152, 18)

                    let dataToSave = await this.getPreparedDataToSave()
                    const pageWidth = pdf.getPageWidth()
                    const tableHeadersPDF = this.createPDFTableHeaders(dataToSave[0], pageWidth)

                    pdf.table(10, 40, dataToSave, tableHeadersPDF, {
                        fontSize: 10,
                        margins: {
                            top: 10,
                            bottom: 10,
                            left: 0,
                            width: 'auto'
                        }
                    })
                    pdf.save(this.title + '.pdf')
                })
            } else {
                img.src = require('@/assets/images/logo-black.png')

                let dataToSave = await this.getPreparedDataToSave()

                pdf.addImage(img, 'png', 150, 10, 152, 18)
                const pageWidth = pdf.getPageWidth()
                const tableHeadersPDF = this.createPDFTableHeaders(dataToSave[0], pageWidth)

                pdf.table(10, 40, dataToSave, tableHeadersPDF, {
                    fontSize: 10,
                    margins: {
                        top: 10,
                        bottom: 10,
                        left: 0,
                        width: 'auto'
                    }
                })
                pdf.save(this.title + '.pdf')
            }
        },
        createPDFTableHeaders (data) {
            const headers = []
            const keys = Object.keys(data)
            const columnWidth = Math.floor(565 / keys.length)
            keys.forEach(key => {
                headers.push({
                    id: key,
                    name: key,
                    prompt: camelCaseToSentence(key),
                    width: columnWidth,
                    align: 'left',
                    padding: 0
                })
            })
            return headers
        },
        deleteCount () {
            if (true === this.deleteConfirmationDialog && !this.singleDelete) {
                this.tempDeleteCount = this.singleDelete ? 1 : this.selected.length
            } else if (true === this.deleteConfirmationDialog && this.singleDelete) {
                this.tempDeleteCount = 1
            }

            return this.tempDeleteCount
        },
        resetFilters () {
            this.resetFiltersHandler()
            this.getItems()
        }
    }
}
</script>

<style scoped lang="scss">
.margin-right {
    margin-right: 10px !important;
}

.table-buttons {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;

    & > * {
        margin-bottom: 10px;
    }
}
</style>
